var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.486 13.472C6.0613 13.472 6.52767 13.0056 6.52767 12.4303C6.52767 11.855 6.0613 11.3887 5.486 11.3887C4.91071 11.3887 4.44434 11.855 4.44434 12.4303C4.44434 13.0056 4.91071 13.472 5.486 13.472Z",
    fill: "#57689F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2501 3.75H3.75008C3.19755 3.75 2.66764 3.96949 2.27694 4.36019C1.88624 4.7509 1.66675 5.2808 1.66675 5.83333L1.66675 16.25H18.3334V5.83333C18.3334 5.2808 18.1139 4.7509 17.7232 4.36019C17.3325 3.96949 16.8026 3.75 16.2501 3.75ZM3.75008 5.13889H16.2501C16.4343 5.13889 16.6109 5.21205 16.7411 5.34229C16.8714 5.47252 16.9445 5.64916 16.9445 5.83333V7.22222H3.05564V5.83333C3.05564 5.64916 3.1288 5.47252 3.25903 5.34229C3.38927 5.21205 3.5659 5.13889 3.75008 5.13889ZM3.05564 14.8611V8.61111H16.9445V14.8611H3.05564Z",
    fill: "#57689F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.b305c2b0fe87f4a253050f518c448c22.svg";
export { ForwardRef as ReactComponent };